import { createUseStyles } from 'react-jss';

interface Props {
  weekNumberMode?: boolean;
  isWeekNumber?: boolean;
  date?: any;
  dateRange?: any;
  start?: any;
  end?: any;
  presetDateRange?: any;
  moment?: any;
};

const useStyles = createUseStyles((theme: any) => ({
  root: {
    position: 'relative',
    width: (props: Props) => props.weekNumberMode ? 'calc(100% / 8)' : 'calc(100% / 7)',
    height: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    '& .fontGray': {
      color: '#bcbcbc',
    },
    '&.range': {
      backgroundColor: '#fffaca',
    },
    '&.start': {
      backgroundColor: '#fffaca',
      borderTopLeftRadius: '50%',
      borderBottomLeftRadius: '50%',
    },
    '&.end': {
      backgroundColor: '#fffaca',
      borderTopRightRadius: '50%',
      borderBottomRightRadius: '50%',
    },
    '&.single': {
      backgroundColor: '#fffaca',
    },
    '&.weekNumber': {
      backgroundColor: '#ececec',
      borderRadius: 'none',
      '& span': {
        color: '#bcbcbc',
      }
    }
  },
  disabled: {
    position: 'relative',
    width: (props: Props) => props.weekNumberMode ? 'calc(100% / 8)' : 'calc(100% / 7)',
    height: '40px',
    display: 'flex',
    cursor: 'not-allowed',
    justifyContent: 'center',
    alignItems: 'center',
    '& .fontGray': {
      color: '#bcbcbc',
    },
    '&.weekNumber': {
      borderRadius: '0%',
      '& span': {
        backgroundColor: '#ececec',
        color: theme.colors.black,
        fontWeight: 'normal',
      }
    }
  },
  date: {
    width: '100%',
    height: '100%',
    textAlign: 'center',
    fontSize: (props: Props) => !props.isWeekNumber ?  '12px' : '11px',
    backgroundColor: (props: Props) => (props.moment(props.date).day() === 0 || props.moment(props.date).day() === 6) ? '#F6F6F6' : theme.colors.white, 
    color: (props: Props) => props.end && props.presetDateRange.start !== null ? (props.moment(props.date).isSameOrAfter(props.moment(props.dateRange.start),'day')) ? theme.colors.black: theme.colors.grey[570] : theme.colors.black,
    cursor: (props: Props) => props.isWeekNumber ? 'auto' : props.end && props.presetDateRange.start !== null ? (props.moment(props.date).isSameOrAfter(props.moment(props.dateRange.start),'day')) ? "pointer": "not-allowed" : "pointer",
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    '&::before': {
      content: `''`,
      position: 'absolute',
      top: '0',
      left: '0',
      right: '0',
      bottom: '0',
      borderRadius: '100%',
    },
    '&:hover::before': {
      border:  (props: Props) => props.end && props.presetDateRange.start !== null ? (props.moment(props.date).isSameOrAfter(props.moment(props.dateRange.start),'day')) ? '1px solid ' + theme.colors.primaryBlue[500]: "" : '1px solid ' + theme.colors.primaryBlue[500],
    },
    '&.today::before': {
      backgroundColor: '#E5F4FF',
    },
    '&.today': {
      color: theme.colors.black,
      fontWeight: 'bold',
    },
    '&.selected::before': {
      backgroundColor: theme.colors.primaryBlue[500],
    },
    '&.selected': {
      color: theme.colors.white,
      fontWeight: 'bold',
    },
    '& p': {
      position: 'relative',
      zIndex: '2',
      marginBottom: '0',
      color: 'inherit',
    },
  },
}));

export default useStyles;